import { connect } from 'react-redux';
import { actions } from '../../../../../../redux/modules/administrativos/administrativos';
import AdministrativosResumen from "./ResumenAdministrativos";


const ms2p = (state) => {
  return {
    ...state.administrativos,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(AdministrativosResumen);
